export default "__VITE_ASSET__BxrSyR0G__"